import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export default function ABreadCrumb({
	currentPage,
	parents,
	className,
	mappedUrl,
}) {
	const cName = !parents ? 'a-breadcrumb--large' : '';
	let parent;
	let cPage = <p>{currentPage}</p>;

	if (parents) {
		let url = '';
		parent = parents.map((item, index) => {
			url = `${url}/${mappedUrl && mappedUrl.length > index ? mappedUrl[index] : item}`;

			return (
				<li key={item}>
					<Link href={url} to={url}>{item}</Link>
				</li>
			);
		});
	}

	if (!parents) {
		cPage = <FormattedMessage id={currentPage} defaultMessage="" />;
	}

	return (
		<section className={`a-breadcrumb ${cName} ${className}`}>
			<ul>
				{parent}
				<li>{cPage}</li>
			</ul>
		</section>
	);
}

ABreadCrumb.propTypes = {
	currentPage: PropTypes.string.isRequired,
	parents: PropTypes.array,
	className: PropTypes.string,
	mappedUrl: PropTypes.array,
};

ABreadCrumb.defaultProps = {
	parents: undefined,
	className: undefined,
	mappedUrl: undefined,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.breadcrumb.js